// Calendario comune Orbit — domeniche e festività nazionali italiane.
// Fonte semantica UNICA lato frontend (nessuna lista duplicata nei singoli componenti).
// La classificazione dipende dalla data civile italiana.

// Domenica di Pasqua (algoritmo di Meeus/Jones/Butcher, calendario gregoriano).
export function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=marzo, 4=aprile
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

export function easterMonday(year) {
  const es = easterSunday(year);
  return new Date(es.getFullYear(), es.getMonth(), es.getDate() + 1);
}

// Festività nazionali a data fissa: "MM-DD" -> nome
const FIXED_HOLIDAYS = {
  "01-01": "Capodanno",
  "01-06": "Epifania",
  "04-25": "Festa della Liberazione",
  "05-01": "Festa del Lavoro",
  "06-02": "Festa della Repubblica",
  "08-15": "Ferragosto",
  "11-01": "Ognissanti",
  "12-08": "Immacolata Concezione",
  "12-25": "Natale",
  "12-26": "Santo Stefano",
};

const p2 = (n) => String(n).padStart(2, "0");

// Accetta un Date (interpretato come data civile) o una stringa "YYYY-MM-DD".
function toParts(input) {
  if (typeof input === "string") {
    const [y, m, d] = input.split("-").map(Number);
    return { y, m, d };
  }
  return { y: input.getFullYear(), m: input.getMonth() + 1, d: input.getDate() };
}

export function holidayNameFor(input) {
  const { y, m, d } = toParts(input);
  const fixed = FIXED_HOLIDAYS[`${p2(m)}-${p2(d)}`];
  if (fixed) return fixed;
  const em = easterMonday(y);
  if (em.getMonth() + 1 === m && em.getDate() === d) return "Lunedì dell'Angelo";
  return null;
}

export function classifyDate(input) {
  const { y, m, d } = toParts(input);
  const dow = new Date(y, m - 1, d).getDay(); // 0=domenica
  const name = holidayNameFor(input);
  return {
    isSunday: dow === 0,
    isNationalHoliday: name !== null,
    holidayName: name,
  };
}
